const assets = 'https://customer-assets-lqy194kg.emergentagent.net/job_portfolio-landing-96/artifacts/';
export const mediumProfile = 'https://medium.com/@vijeesh91';
export const articles = [
  {
    id: 'ux-ai', title: 'Great UX designers don’t beat AI at speed.', time: '6 min read',
    image: `${assets}5so3ftm5_Writting%20IMG%201.webp`,
    alt: 'Two designers building a bridge together over a divide',
    description: 'For years, we’ve rewarded designers for producing artifacts: beautiful screens, perfect prototypes, polished portfolios, and pixel-perfect case studies. AI excels at producing all of these things…',
    url: 'https://medium.com/@vijeesh91/the-best-ux-designers-arent-faster-than-ai-they-re-better-at-seeing-what-ai-misses-154d0923e148',
  },
  {
    id: 'agentic-ai', title: 'How Agentic AI Is Changing Product Design Forever', time: '7 min read',
    image: `${assets}h4iu5htg_Writting%20IMG%202.webp`,
    alt: 'An illustrated mind surrounded by connected conversation bubbles on an orange background',
    description: 'We are entering the era of Agentic AI, where software no longer waits for instructions. Instead, it understands goals, plans actions, makes decisions, and executes complex workflows…',
    url: 'https://medium.com/@vijeesh91/how-agentic-ai-is-changing-product-design-forever-bc611fb785e4',
  },
];
export const patent = {
  image: `${assets}stbeuy0f_caspopp.webp`,
  title: 'Smart cooking system that produces and uses hydrogen fuel',
  years: '2016–2018',
  description: 'An intelligent cooking system device is provided with processing, communications, and other information technology components, for remote monitoring and control and various value added features and services, embodiments of which use a renewable energy-powered electrolyser to produce hydrogen as an on-demand fuel stream for a heating element of the cooking system.',
  links: [
    { label: 'US', url: 'https://patents.google.com/patent/US20190056107A1/en?inventor=Vijeesh+Thattante+Valappil&oq=Vijeesh+Thattante+Valappil' },
    { label: 'EU', url: 'https://patents.google.com/patent/EP3411265B1/en?inventor=Vijeesh+Thattante+Valappil&oq=Vijeesh+Thattante+Valappil' },
    { label: 'WIPO', url: 'https://patents.google.com/patent/WO2017136489A1/en' },
  ],
};